import React from "react";
import ServicesCard from "./SevicesCards";
import { Container, Heading, SimpleGrid } from "@chakra-ui/react";
import { CgWebsite } from "react-icons/cg";
import { MdOutlineDesignServices, MdBrandingWatermark, MdComputer } from "react-icons/md";
import { BiShoppingBag } from "react-icons/bi";
const Services = () => {
    return (
        <Container maxW={"container.lg"} my="6">
            <Heading size={"md"} className="text-center mt-12 mb-2 font-mono font-bold text-2xl">
                Technology Services That I Can Offer
            </Heading>
            <hr className="mb-6 mx-60 border-blue-300 dark:border-lime-300" />
            <SimpleGrid columns={[1, 2, 3]} spacing="2">
                <ServicesCard
                sp={"bg-white dark:bg-lime-300"}
                    icon={<MdOutlineDesignServices />}
                    title="Website Design"
                    text={
                        "I Can Design front end website. also make it very gorgeous and beautiful if i got some time."
                    }
                    rating="4.9"
                />
                <ServicesCard
                    sp={"bg-white dark:bg-lime-300"}
                    icon={<CgWebsite />}
                    title="Full-Stack Website"
                    text={
                        "I can Develop a Full-stack website (MERN) from backend to client end . Fully functional."
                    }
                    rating="4.9"
                />
                <ServicesCard
                    sp={"bg-white dark:bg-lime-300"}
                    icon={<MdComputer/>}
                    title="WordPress Website "
                    text={
                        "I offer CMS-based (Content management system) website development. WordPress Theme Customization."
                    }
                    rating="4.9"
                />

                <ServicesCard
                sp={"bg-white dark:bg-lime-300"}
                    icon={<BiShoppingBag />}
                    title="E-comerce Solution"
                    text={
                        "Optimize & improve the functionality of the e-commerce site through perfectly developed Plug-ins and high-end modules."
                    }
                    rating="4.9"
                />
                <ServicesCard
                sp={"bg-white dark:bg-lime-300"}
                    icon={<MdBrandingWatermark />}
                    title="Design & Branding"
                    text={
                        "I Can Make Brand Identity like Animation, Logo, Banner, Promo Videos, Web Templates etc. I take care of everything behind the design to make it work flawlessly."
                    }
                    rating="4.9"
                />
            </SimpleGrid>
        </Container>
    );
};

export default Services;
